var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "ma-0" },
    [
      _c(
        "v-col",
        { staticClass: "wsp-wallpaper pb-5", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "mx-4 mt-4 mb-0 py-2" },
            [
              _vm.replyMessageSelected.image_url
                ? _c("v-col", { staticClass: "pb-0", attrs: { cols: "12" } }, [
                    _c("img", {
                      attrs: {
                        src: _vm.replyMessageSelected.image_url,
                        width: "100%",
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.replyMessageSelected.caption
                ? _c(
                    "v-col",
                    {
                      staticClass: "py-1 font-weight-bold",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.replyMessageSelected.caption)),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.replyMessageSelected.content
                ? _c("v-col", { staticClass: "py-1", attrs: { cols: "12" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replyMessageSelected.content)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.replyMessageSelected.footer
                ? _c(
                    "v-col",
                    {
                      staticClass: "py-1 text-caption text--secondary",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.replyMessageSelected.footer)),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "py-0 text-caption text--secondary text-right",
                  attrs: { cols: "12" },
                },
                [_c("span", [_vm._v("07:42")])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.replyMessageSelected.buttons
            ? _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                _vm._l(_vm.replyMessageSelected.buttons, function (button, i) {
                  return _c(
                    "v-card",
                    {
                      key: i,
                      staticClass: "mx-1 mt-1 py-1 text-center info--text",
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(button.reply.title) + "\n      "
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.replyMessageSelected.list_options ||
          _vm.replyMessageSelected.sections
            ? _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "mx-1 mt-1 py-1 text-center info--text" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-1",
                          attrs: { "x-small": "", color: "info" },
                        },
                        [_vm._v(" fas fa-bars")]
                      ),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.replyMessageSelected.action_button) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }